import axiosCall from './interceptor';
import URL from '../helper';

let GOOGLE_FONTS_API_KEY;

const getGoogleAPIKey = async () => {
  const url = `${URL.BASE_URL}getGoogleFontAPIKey`;
  let result = await axiosCall('get', url);
  if (result.data?.statusCode === 522) {
    GOOGLE_FONTS_API_KEY = result.data.data;
  }
  return result.data;
};

export const getGoogleFonts = async () => {
  if (GOOGLE_FONTS_API_KEY === undefined) {
    await getGoogleAPIKey();
  }
  let result = await fetch(`https://www.googleapis.com/webfonts/v1/webfonts?key=${GOOGLE_FONTS_API_KEY}`, { method: 'get' })
    .then(res => res.text())
    .then(response => JSON.parse(response));
  return result.items;
};

export const getAllFonts = async () => {
  const url = `${URL.BASE_URL}fonts`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getAllOpenFonts = async () => {
  const url = `${URL.BASE_URL}openFonts`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const uploadGoogleFonts = async payload => {
  const url = `${URL.BASE_URL}googlefonts`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};
